/* eslint-disable */
/* tslint:disable */
/* Do not edit - generated by swagger-typescript-api */

import { ApplicationSettingsCollectionResponse, ErrorResponse } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';
export class Settings<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }
  /**
   * No description
   *
   * @tags Settings
   * @name SettingsList
   * @request GET:/Settings
   * @response `200` `ApplicationSettingsCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  settingsList = (params: RequestParams = {}) =>
    this.http.request<ApplicationSettingsCollectionResponse, ErrorResponse>({
      path: `/Settings`,
      method: 'GET',
      format: 'json',
      ...params,
    });
}
